import ResearcherLeftNav from './ResearcherLeftNav.js';

export default ResearcherLeftNav;
